@if (!formSubmitted) {
  <div class="container">
    <div class="row">
      <div class="col-4">
        <img
          class="logo"
          src="../assets/images/logo.png"
          alt="Rene Egli windsurfing and Kitesurfing Fuerteventura Logo"
        />
      </div>
      <div class="col-8">
        <label class="col-form-label float-right">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-globe"></i>
              </span>
            </div>
            <select
              #languageSelect
              class="form-control"
              (change)="changeLanguage(languageSelect.value)"
            >
              @for (lang of translate.getLangs(); track lang) {
                <option
                  [value]="lang"
                  [selected]="lang === translate.currentLang"
                >
                  {{ lang }}
                </option>
              }
            </select>
          </div>
        </label>
        <h1 class="text-left" translate>header</h1>
      </div>
    </div>
    <form [formGroup]="requestForm" (ngSubmit)="onSubmit()">
      <div formArrayName="persons">
        @for (
          person of requestForm["controls"].persons["controls"];
          track person;
          let i = $index
        ) {
          <div>
            <div formGroupName="{{ i }}">
              <hr />
              <div class="form-row">
                <div class="col-sm-10">
                  @if (
                    requestForm.controls.persons.controls[i].controls.firstName
                      .value == ""
                  ) {
                    <h5>
                      <i class="fa fa-user"></i>
                      {{ "Person details" | translate }}
                    </h5>
                  }
                  @if (
                    requestForm.controls.persons.controls[i].controls.firstName
                      .value !== ""
                  ) {
                    <h5>
                      <i class="fa fa-user"></i>
                      {{
                        requestForm.controls.persons.controls[i].controls
                          .firstName.value
                      }}
                      {{
                        requestForm.controls.persons.controls[i].controls
                          .lastName.value
                      }}
                    </h5>
                  }
                </div>
                <div class="col-sm-2">
                  <button
                    type="button"
                    class="btn btn-danger float-right"
                    (click)="removePerson(i)"
                  >
                    <i class="fa fa-trash-alt"></i>
                    @if (
                      requestForm.controls.persons.controls[i].controls
                        .firstName.value == ""
                    ) {
                      <span> {{ "Remove person" | translate }}</span>
                    }
                    @if (
                      requestForm.controls.persons.controls[i].controls
                        .firstName.value !== ""
                    ) {
                      <span>
                        {{
                          requestForm.controls.persons.controls[i].controls
                            .firstName.value
                        }}</span
                      >
                    }
                  </button>
                </div>
              </div>
              <div class="form-row">
                <div class="col-sm-6 col-lg-4 form-group">
                  <label for="firstName">{{ "First name:" | translate }}</label>
                  <input
                    class="form-control"
                    type="text"
                    formControlName="firstName"
                  />
                </div>
                <div class="col-sm-6 col-lg-4 col-xl-5 form-group">
                  <label for="lastName">{{ "Last name:" | translate }}</label>
                  <input
                    class="form-control"
                    type="text"
                    formControlName="lastName"
                  />
                </div>
                <div class="col-sm-6 col-lg-4 col-xl-3 form-group">
                  <label for="dateOfBirth">{{
                    "Date of birth:" | translate
                  }}</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">
                        <i class="fa fa-birthday-cake"></i>
                      </span>
                    </div>
                    <input
                      class="form-control"
                      type="date"
                      formControlName="dateOfBirth"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 form-group">
                  <button
                    type="button"
                    class="btn btn-primary mr-3"
                    (click)="addEquipment(i)"
                  >
                    <i class="fa fa-plus"></i> {{ "Add gear" | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mr-3"
                    (click)="addWindsurfLesson(i)"
                  >
                    <i class="fa fa-plus"></i>
                    {{ "Add Windsurf lesson" | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mr-3"
                    (click)="addKitesurfLesson(i)"
                  >
                    <i class="fa fa-plus"></i>
                    {{ "Add Kitesurf lesson" | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary mr-3"
                    (click)="addWingfoilLesson(i)"
                  >
                    <i class="fa fa-plus"></i>
                    {{ "Add Wingfoil lesson" | translate }}
                  </button>
                  <button
                    type="button"
                    class="btn btn-primary"
                    (click)="addStorage(i)"
                  >
                    <i class="fa fa-plus"></i> {{ "Add storage" | translate }}
                  </button>
                </div>
              </div>
              <div class="list-group" formArrayName="equipments">
                @for (
                  equipment of person.controls["equipments"].controls;
                  track equipment;
                  let j = $index
                ) {
                  <div>
                    <div class="form-row" formGroupName="{{ j }}">
                      <div class="col-sm-1 form-group"></div>
                      <div class="col-sm-11 form-group">
                        <hr />
                        <div class="form-row">
                          <div class="col-sm-10 col-lg-9">
                            <h5>
                              {{ "Equipment" | translate }} {{ j + 1 }}
                              {{ "for" | translate }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.firstName.value
                              }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.lastName.value
                              }}:
                            </h5>
                          </div>
                          <div class="col-sm-2 col-lg-3 form-group">
                            <button
                              type="button"
                              class="btn btn-danger float-right"
                              (click)="removeEquipment(i, j)"
                            >
                              <i class="fa fa-trash-alt"></i>
                              {{ "Remove gear" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-6 col-lg-4 form-group">
                            <label for="type">{{ "Type:" | translate }}</label>
                            <select class="form-control" formControlName="type">
                              <option value="Wing PREMIUM">Wing PREMIUM</option>
                              <option disabled>
                                ──────────────────────────
                              </option>
                              <option value="Windsurf PREMIUM">
                                Windsurf PREMIUM
                              </option>
                              <option value="Windsurf WORLD CUP">
                                Windsurf WORLD CUP
                              </option>
                              <option value="Windsurf KIDS">
                                Windsurf KIDS
                              </option>
                              <option disabled>
                                ──────────────────────────
                              </option>
                              <option value="Kitesurf PREMIUM">
                                Kitesurf PREMIUM
                              </option>
                              <option disabled>
                                ──────────────────────────
                              </option>
                              <option value="Combined Wind- & Kitesurf PREMIUM">
                                {{
                                  "Combined Wind- & Kitesurf PREMIUM"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Combined Wind- & Kitesurf WORLD CUP"
                              >
                                {{
                                  "Combined Wind- & Kitesurf WORLD CUP"
                                    | translate
                                }}
                              </option>
                              <option value="Combined Windsurf & Wing PREMIUM">
                                {{
                                  "Combined Windsurf & Wing PREMIUM" | translate
                                }}
                              </option>
                              <option value="Combined Kitesurf & Wing PREMIUM">
                                {{
                                  "Combined Kitesurf & Wing PREMIUM" | translate
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-4 col-lg-4 col-xl-3 form-group">
                            <label for="beginn">{{
                              "Start:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-calendar"></i>
                                </span>
                              </div>
                              <input
                                class="form-control"
                                type="date"
                                formControlName="beginn"
                              />
                            </div>
                          </div>
                          <div class="col-sm-6 col-lg-4 col-xl-5 form-group">
                            <label for="duration">{{
                              "Duration:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-clock"></i>
                                </span>
                              </div>
                              <select
                                class="form-control"
                                formControlName="duration"
                              >
                                @for (
                                  equipmentDuration of equipmentDurations;
                                  track equipmentDuration
                                ) {
                                  <option [value]="equipmentDuration">
                                    {{ equipmentDuration | translate }}
                                  </option>
                                }
                              </select>
                            </div>
                          </div>
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Wing PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Windsurf & Wing PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Kitesurf & Wing PREMIUM"
                          ) {
                            <div class="col-sm-6 col-lg-4 form-group">
                              <label for="board">Wing PREMIUM Fixboard:</label>
                              <select
                                class="form-control"
                                formControlName="board"
                              >
                                @for (
                                  equipmentWingPremiumBoard of equipmentWingPremiumBoards;
                                  track equipmentWingPremiumBoard
                                ) {
                                  <option [value]="equipmentWingPremiumBoard">
                                    {{ equipmentWingPremiumBoard }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Windsurf PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Wind- & Kitesurf PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Windsurf & Wing PREMIUM"
                          ) {
                            <div class="col-sm-6 col-lg-4 form-group">
                              <label for="board"
                                >Windsurf PREMIUM Fixboard:</label
                              >
                              <select
                                class="form-control"
                                formControlName="board"
                              >
                                @for (
                                  equipmentWindsurfPremiumBoard of equipmentWindsurfPremiumBoards;
                                  track equipmentWindsurfPremiumBoard
                                ) {
                                  <option
                                    [value]="equipmentWindsurfPremiumBoard"
                                  >
                                    {{ equipmentWindsurfPremiumBoard }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Windsurf WORLD CUP" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Wind- & Kitesurf WORLD CUP"
                          ) {
                            <div class="col-sm-6 col-lg-4 form-group">
                              <label for="board"
                                >Windsurf WORLD CUP Fixboard:</label
                              >
                              <select
                                class="form-control"
                                formControlName="board"
                              >
                                @for (
                                  equipmentWindsurfWorldCupBoard of equipmentWindsurfWorldCupBoards;
                                  track equipmentWindsurfWorldCupBoard
                                ) {
                                  <option
                                    [value]="equipmentWindsurfWorldCupBoard"
                                  >
                                    {{ equipmentWindsurfWorldCupBoard }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                            "Windsurf KIDS"
                          ) {
                            <div class="col-sm-6 col-lg-4 form-group">
                              <label for="board">Windsurf KIDS Fixboard:</label>
                              <select
                                class="form-control"
                                formControlName="board"
                              >
                                @for (
                                  equipmentWindsurfKidsBoard of equipmentWindsurfKidsBoards;
                                  track equipmentWindsurfKidsBoard
                                ) {
                                  <option [value]="equipmentWindsurfKidsBoard">
                                    {{ equipmentWindsurfKidsBoard }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Kitesurf PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Wind- & Kitesurf PREMIUM" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Wind- & Kitesurf WORLD CUP" ||
                            requestForm.controls.persons.controls[i].controls
                              .equipments.controls[j].controls.type.value ==
                              "Combined Kitesurf & Wing PREMIUM"
                          ) {
                            <div class="col-sm-6 col-lg-4 form-group">
                              <label for="board"
                                >Kitesurf PREMIUM Fixboard:</label
                              >
                              <select
                                class="form-control"
                                formControlName="board"
                              >
                                @for (
                                  equipmentKitesurfPremiumBoard of equipmentKitesurfPremiumBoards;
                                  track equipmentKitesurfPremiumBoard
                                ) {
                                  <option
                                    [value]="equipmentKitesurfPremiumBoard"
                                  >
                                    {{ equipmentKitesurfPremiumBoard }}
                                  </option>
                                }
                              </select>
                            </div>
                          }
                        </div>
                        <div class="form-row">
                          <div class="col-sm-4 col-lg-3 col-xl-2 form-group">
                            <label for="insurance">{{
                              "Insurance:" | translate
                            }}</label>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="insurance"
                                />{{ "Material insurance" | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-4 col-lg-3 col-xl-2 form-group">
                            <label for="accessories">{{
                              "Accessories:" | translate
                            }}</label>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="wetsuit"
                                />{{ "Wetsuit" | translate }}
                              </label>
                            </div>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="harness"
                                />{{ "Harness" | translate }}
                              </label>
                            </div>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="helmet"
                                />{{ "Helmet" | translate }}
                              </label>
                            </div>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="lifeVest"
                                />{{ "Life vest" | translate }}
                              </label>
                            </div>
                          </div>
                          <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                            <label for="accessories">{{
                              "Specials:" | translate
                            }}</label>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="doubleUse"
                                />{{ "Double use (with child)" | translate }}
                              </label>
                            </div>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="partnerSpecial"
                                />{{
                                  "Partner special (without child)" | translate
                                }}
                              </label>
                            </div>
                            <div class="form-check">
                              <label class="form-check-label">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  formControlName="privateRental"
                                />{{
                                  "Private rental (for take away)" | translate
                                }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="list-group" formArrayName="windsurfLessons">
                @for (
                  windsurfLesson of person.controls["windsurfLessons"].controls;
                  track windsurfLesson;
                  let k = $index
                ) {
                  <div>
                    <div class="form-row" formGroupName="{{ k }}">
                      <div class="col-sm-1 form-group"></div>
                      <div class="col-sm-11 form-group">
                        <hr />
                        <div class="form-row">
                          <div class="col-sm-10">
                            <h5>
                              {{ "Windsurf lesson" | translate }} {{ k + 1 }}
                              {{ "for" | translate }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.firstName.value
                              }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.lastName.value
                              }}:
                            </h5>
                          </div>
                          <div class="col-sm-2 form-group">
                            <button
                              type="button"
                              class="btn btn-danger float-right"
                              (click)="removeWindsurfLesson(i, k)"
                            >
                              <i class="fa fa-trash-alt"></i>
                              {{ "Remove windsurf Lesson" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-10 col-lg-6 form-group">
                            <label for="type">{{
                              "Course type:" | translate
                            }}</label>
                            <select class="form-control" formControlName="type">
                              <option
                                value="Beginner combi (A-course & 4h hourly rental + 2h extra hours)"
                              >
                                {{
                                  "Beginner combi (A-course & 4h hourly rental + 2h extra hours)"
                                    | translate
                                }}
                              </option>
                              <option value="A/K Trial course">
                                {{ "A/K Trial course" | translate }}
                              </option>
                              <option value="K-course (Kids 8-12 years)">
                                {{ "K-course (Kids 8-12 years)" | translate }}
                              </option>
                              <option value="A-course (Beginner)">
                                {{ "A-course (Beginner)" | translate }}
                              </option>
                              <option value="A1-course (Refresher)">
                                {{ "A1-course (Refresher)" | translate }}
                              </option>
                              <option value="F1-course (Waterstart)">
                                {{ "F1-course (Waterstart)" | translate }}
                              </option>
                              <option
                                value="F2-course (Planing position, Footstraps)"
                              >
                                {{
                                  "F2-course (Planing position, Footstraps)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="F3-course (Surfing through shore break, speed, power jibe)"
                              >
                                {{
                                  "F3-course (Surfing through shore break, speed, power jibe)"
                                    | translate
                                }}
                              </option>
                              <option value="F2+F3 combi (4 hours)">
                                {{ "F2+F3 combi (4 hours)" | translate }}
                              </option>
                              <option value="Private Lessons">
                                {{ "Private lessons" | translate }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                            <label for="beginn">{{
                              "Desired start:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-calendar"></i>
                                </span>
                              </div>
                              <input
                                class="form-control"
                                type="date"
                                formControlName="beginn"
                              />
                            </div>
                          </div>
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .windsurfLessons.controls[k].controls.type
                              .value == "K-course (Kids 8-12 years)" ||
                            requestForm.controls.persons.controls[i].controls
                              .windsurfLessons.controls[k].controls.type
                              .value == "A-course (Beginner)" ||
                            requestForm.controls.persons.controls[i].controls
                              .windsurfLessons.controls[k].controls.type
                              .value == "A1-course (Refresher)"
                          ) {
                            <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                              <label for="hourlyRental">{{
                                "Hourly rental:" | translate
                              }}</label>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <i class="fa fa-clock"></i>
                                  </span>
                                </div>
                                <select
                                  class="form-control"
                                  formControlName="hourlyRental"
                                >
                                  <option value="4h">4h</option>
                                  <option value="6h">6h</option>
                                  <option value="10h">10h</option>
                                </select>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="list-group" formArrayName="kitesurfLessons">
                @for (
                  kitesurfLesson of person.controls["kitesurfLessons"].controls;
                  track kitesurfLesson;
                  let l = $index
                ) {
                  <div>
                    <div class="form-row" formGroupName="{{ l }}">
                      <div class="col-sm-1 form-group"></div>
                      <div class="col-sm-11 form-group">
                        <hr />
                        <div class="form-row">
                          <div class="col-sm-10">
                            <h5>
                              {{ "Kitesurf lesson" | translate }} {{ l + 1 }}
                              {{ "for" | translate }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.firstName.value
                              }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.lastName.value
                              }}:
                            </h5>
                          </div>
                          <div class="col-sm-2 form-group">
                            <button
                              type="button"
                              class="btn btn-danger float-right"
                              (click)="removeKitesurfLesson(i, l)"
                            >
                              <i class="fa fa-trash-alt"></i>
                              {{ "Remove kitesurf lesson" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-6 form-group">
                            <label for="type">{{
                              "Course type:" | translate
                            }}</label>
                            <select class="form-control" formControlName="type">
                              <option
                                value="Beginner combi (12h course + extra 3h Kite Advanced Pool)"
                              >
                                {{
                                  "Beginner combi (12h course + extra 3h Kite Advanced Pool)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Beginner (Material knowledge & Kitecontrol)"
                              >
                                {{
                                  "Beginner (Material knowledge & Kitecontrol)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Intermediate (Bodydrag & First waterstarts)"
                              >
                                {{
                                  "Intermediate (Bodydrag & First waterstarts)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Upper-Intermediate (Improving the waterstart & Riding)"
                              >
                                {{
                                  "Upper-Intermediate (Improving the waterstart & Riding)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Advanced (Controlled & Upwind riding)"
                              >
                                {{
                                  "Advanced (Controlled & Upwind riding)"
                                    | translate
                                }}
                              </option>
                              <option disabled>
                                ───────────────────────────────────────────
                              </option>
                              <option
                                value="Kite Advanced Pool (Supervised equipment rental)"
                              >
                                {{
                                  "Kite Advanced Pool (Supervised equipment rental)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Private Lessons 2h (From beginner to advanced, jumps, foil & strapless)"
                              >
                                {{
                                  "Private Lessons 2h (From beginner to advanced, jumps, foil & strapless)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Private Lessons 4h (From beginner to advanced, jumps, foil & strapless)"
                              >
                                {{
                                  "Private Lessons 4h (From beginner to advanced, jumps, foil & strapless)"
                                    | translate
                                }}
                              </option>
                            </select>
                            <span class="form-text text-muted">
                              {{ "KitesurfLessonTypeInfo" | translate }}
                            </span>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                            <label for="beginn">{{
                              "Desired start:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-calendar"></i>
                                </span>
                              </div>
                              <input
                                class="form-control"
                                type="date"
                                formControlName="beginn"
                              />
                            </div>
                          </div>
                          @if (
                            requestForm.controls.persons.controls[i].controls
                              .kitesurfLessons.controls[l].controls.type
                              .value ==
                              "Beginner (Material knowledge & Kitecontrol)" ||
                            requestForm.controls.persons.controls[i].controls
                              .kitesurfLessons.controls[l].controls.type
                              .value ==
                              "Intermediate (Bodydrag & First waterstarts)" ||
                            requestForm.controls.persons.controls[i].controls
                              .kitesurfLessons.controls[l].controls.type
                              .value ==
                              "Upper-Intermediate (Improving the waterstart & Riding)" ||
                            requestForm.controls.persons.controls[i].controls
                              .kitesurfLessons.controls[l].controls.type
                              .value ==
                              "Advanced (Controlled & Upwind riding)" ||
                            requestForm.controls.persons.controls[i].controls
                              .kitesurfLessons.controls[l].controls.type
                              .value ==
                              "Kite Advanced Pool (Supervised equipment rental)"
                          ) {
                            <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                              <label for="duration">{{
                                "Duration:" | translate
                              }}</label>
                              <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text">
                                    <i class="fa fa-clock"></i>
                                  </span>
                                </div>
                                <select
                                  class="form-control"
                                  formControlName="duration"
                                >
                                  <option value="3h">3h</option>
                                  <option value="6h">6h</option>
                                  <option value="9h">9h</option>
                                  <option value="12h">12h</option>
                                </select>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="list-group" formArrayName="wingfoilLessons">
                @for (
                  wingfoilLesson of person.controls["wingfoilLessons"].controls;
                  track wingfoilLesson;
                  let m = $index
                ) {
                  <div>
                    <div class="form-row" formGroupName="{{ m }}">
                      <div class="col-sm-1 form-group"></div>
                      <div class="col-sm-11 form-group">
                        <hr />
                        <div class="form-row">
                          <div class="col-sm-10">
                            <h5>
                              {{ "Wingfoil lesson" | translate }} {{ m + 1 }}
                              {{ "for" | translate }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.firstName.value
                              }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.lastName.value
                              }}:
                            </h5>
                          </div>
                          <div class="col-sm-2 form-group">
                            <button
                              type="button"
                              class="btn btn-danger float-right"
                              (click)="removeWingfoilLesson(i, m)"
                            >
                              <i class="fa fa-trash-alt"></i>
                              {{ "Remove wingfoil lesson" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-6 form-group">
                            <label for="type">{{
                              "Course type:" | translate
                            }}</label>
                            <select class="form-control" formControlName="type">
                              <option
                                value="Private Lessons 2h (From beginner to advanced, jumps, foil & strapless)"
                              >
                                {{
                                  "Private Lessons 2h (From beginner to advanced, jumps, foil & strapless)"
                                    | translate
                                }}
                              </option>
                              <option
                                value="Private Lessons 4h (From beginner to advanced, jumps, foil & strapless)"
                              >
                                {{
                                  "Private Lessons 4h (From beginner to advanced, jumps, foil & strapless)"
                                    | translate
                                }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-5 col-lg-4 col-xl-3 form-group">
                            <label for="beginn">{{
                              "Desired start:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-calendar"></i>
                                </span>
                              </div>
                              <input
                                class="form-control"
                                type="date"
                                formControlName="beginn"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
              <div class="list-group" formArrayName="storages">
                @for (
                  storage of person.controls["storages"].controls;
                  track storage;
                  let n = $index
                ) {
                  <div>
                    <div class="form-row" formGroupName="{{ n }}">
                      <div class="col-sm-1 form-group"></div>
                      <div class="col-sm-11 form-group">
                        <hr />
                        <div class="form-row">
                          <div class="col-sm-10">
                            <h5>
                              {{ "Storage package" | translate }} {{ n + 1 }}
                              {{ "for" | translate }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.firstName.value
                              }}
                              {{
                                requestForm.controls.persons.controls[i]
                                  .controls.lastName.value
                              }}:
                            </h5>
                          </div>
                          <div class="col-sm-2 form-group">
                            <button
                              type="button"
                              class="btn btn-danger float-right"
                              (click)="removeStorage(i, n)"
                            >
                              <i class="fa fa-trash-alt"></i>
                              {{ "Remove storage" | translate }}
                            </button>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="col-sm-5 col-lg-4 form-group">
                            <label for="type">{{ "Type:" | translate }}</label>
                            <select class="form-control" formControlName="type">
                              <option value="Kitesurf Storage 7 days">
                                Kitesurf Storage 7 days
                              </option>
                              <option value="Kitesurf Storage 14 days">
                                Kitesurf Storage 14 days
                              </option>
                              <option value="Kitesurf Storage 21 days">
                                Kitesurf Storage 21 days
                              </option>
                            </select>
                          </div>
                          <div class="col-sm-4 col-lg-3 col-xl-3 form-group">
                            <label for="beginn">{{
                              "Start:" | translate
                            }}</label>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <i class="fa fa-calendar"></i>
                                </span>
                              </div>
                              <input
                                class="form-control"
                                type="date"
                                formControlName="beginn"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
      <hr />
      <div class="form-row">
        <div class="col-1">
          <button type="button" class="btn btn-primary" (click)="addPerson()">
            <i class="fa fa-user-plus"></i> {{ "Add person" | translate }}
          </button>
        </div>
      </div>
      <hr />
      <h5><i class="fa fa-suitcase"></i> {{ "TripDetails" | translate }}</h5>
      <div class="form-row">
        <div class="col-sm-5 col-lg-3 form-group">
          <label for="arrival" translate>Arrival</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-calendar"></i>
              </span>
            </div>
            <input class="form-control" type="date" formControlName="arrival" />
          </div>
        </div>
        <div class="col-sm-5 col-lg-3 form-group">
          <label for="arrival" translate>Departure</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-calendar"></i>
              </span>
            </div>
            <input
              class="form-control"
              type="date"
              formControlName="departure"
            />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-6 form-group">
          <label for="flight" translate>Flight</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-plane"></i>
              </span>
            </div>
            <select class="form-control" formControlName="flight">
              <option value="">{{ "HotelNone" | translate }}</option>
              @for (airport of airports; track airport) {
                <option [value]="airport">
                  {{ airport }}
                </option>
              }
            </select>
          </div>
          <span class="form-text text-muted">
            {{ "FlightInfo" | translate }}
          </span>
        </div>
      </div>
      <div class="form-row align-items-center">
        <div class="col-sm-12 col-lg-6 form-group">
          <label for="hotel" translate>Hotel</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-bed"></i>
              </span>
            </div>
            <select class="form-control" formControlName="hotel">
              <option value="">{{ "HotelNone" | translate }}</option>
              @for (hotel of hotels; track hotel) {
                <option [value]="hotel">
                  {{ hotel | translate }}
                </option>
              }
            </select>
          </div>
        </div>
        @if (requestForm.controls.hotel.value == "temp disabled") {
          <div class="col-sm-6 col-lg-4 form-group">
            <label for="hotel" translate>HotelBoard</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  <i class="fa fa-utensils"></i>
                </span>
              </div>
              <select class="form-control" formControlName="hotelBoard">
                @for (hotelBoard of hotelBoards; track hotelBoard) {
                  <option [value]="hotelBoard">
                    {{ hotelBoard | translate }}
                  </option>
                }
              </select>
            </div>
          </div>
        }
      </div>
      <hr />
      <div class="form-row">
        <div class="col-11">
          <h5>
            <i class="fa fa-shopping-cart"></i>
            {{ "Contact details" | translate }}
          </h5>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="offerName">{{ "Send offer to:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-user"></i>
              </span>
            </div>
            <select class="form-control" formControlName="offerName">
              @for (
                person of requestForm.controls.persons["controls"];
                track person;
                let n = $index
              ) {
                <option [value]="n">
                  {{
                    requestForm.controls.persons.controls[n].controls.firstName
                      .value
                  }}
                  {{
                    requestForm.controls.persons.controls[n].controls.lastName
                      .value
                  }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-6 col-lg-4 col-xl-3 form-group">
          <label for="customerNumber">{{
            "Customer number:" | translate
          }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-heart"></i>
              </span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="customerNumber"
            />
          </div>
        </div>
        <div class="col-sm-6 col-lg-4 col-xl-3 form-group">
          <label for="passportNumber">{{
            "Passport number:*" | translate
          }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-id-card"></i>
              </span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="passportNumber"
            />
          </div>
          <span class="form-text text-muted">
            {{ "PassportInfo" | translate }}
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-6 col-lg-4 col-xl-3 form-group">
          <label for="email">{{ "Email:" | translate }} </label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-at"></i>
              </span>
            </div>
            <input class="form-control" type="text" formControlName="email" />
          </div>
        </div>
        <div class="col-sm-6 col-lg-4 col-xl-3 form-group">
          <label for="phone">{{ "Phone:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-phone"></i>
              </span>
            </div>
            <input class="form-control" type="text" formControlName="phone" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="address">{{ "Street and number:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-home"></i>
              </span>
            </div>
            <input class="form-control" type="text" formControlName="address" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-5 col-lg-2 col-xl-2 form-group">
          <label for="postcode">{{ "Postcode:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-envelope"></i>
              </span>
            </div>
            <input
              class="form-control"
              type="text"
              formControlName="postcode"
            />
          </div>
        </div>
        <div class="col-sm-7 col-lg-6 col-xl-4 form-group">
          <label for="city">{{ "City:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-map-marker"></i>
              </span>
            </div>
            <input class="form-control" type="text" formControlName="city" />
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="country">{{ "Country:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-globe"></i>
              </span>
            </div>
            <select class="form-control" formControlName="country">
              @for (country of countrys; track country) {
                <option [value]="country">
                  {{ country | translate }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="comment">{{ "Remarks:" | translate }}</label>
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-comment-alt"></i>
              </span>
            </div>
            <textarea
              class="form-control"
              rows="5"
              formControlName="comment"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="comment">{{ "PrivacyPolicy" | translate }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="privacy"
              />
              <p
                translate
                [innerHTML]="'PrivacyPolicyText' | translate: param"
              ></p>
            </label>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-sm-12 col-lg-8 col-xl-6 form-group">
          <label for="comment">{{ "Newsletter" | translate }}</label>
          <div class="form-check">
            <label class="form-check-label">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="newsletter"
              />
              <p
                translate
                [innerHTML]="'NewsletterText' | translate: param"
              ></p>
            </label>
          </div>
        </div>
      </div>
      <hr />
      @if (requestForm.controls.email.errors?.required) {
        <div class="text-danger">
          {{ "ValidationNoEmail" | translate }}
        </div>
      }
      @if (requestForm.controls.email.errors?.email) {
        <div class="text-danger">
          {{ "ValidationCheckEmail" | translate }}
        </div>
      }
      @if (!requestForm.controls.privacy.valid) {
        <div class="text-danger">
          {{ "ValidationPrivacy" | translate }}
        </div>
      }
      <div class="form-row">
        <div class="col-12 form-group">
          <button
            type="submit"
            class="btn btn-primary mr-3 booking-send"
            [disabled]="!requestForm.valid"
          >
            <i class="fa fa-share"></i> {{ "Submit" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
}
@if (formSubmitted) {
  <div class="container">
    <div class="row">
      <div class="col-3">
        <img
          src="//www.rene-egli.com/fileadmin/templates/Images/reneegli_logo-neu.png"
          height="120em"
          width=""
          alt="Rene Egli Kitesurf Logo"
        />
      </div>
      <div class="col-9">
        <label class="col-form-label float-right">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="fa fa-globe"></i>
              </span>
            </div>
            <select
              #languageSelect
              class="form-control"
              (change)="changeLanguage(languageSelect.value)"
            >
              @for (lang of translate.getLangs(); track lang) {
                <option
                  [value]="lang"
                  [selected]="lang === translate.currentLang"
                >
                  {{ lang }}
                </option>
              }
            </select>
          </div>
        </label>
        <h1 class="text-left" translate>Booking request has been sent!</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p translate [innerHTML]="'Outro' | translate: param"></p>
      </div>
    </div>
    <div class="form-row">
      <div class="col-12 form-group">
        <a href="//www.rene-egli.com" role="button" class="btn btn-primary mr-3"
          ><i class="fa fa-home"></i> {{ "René Egli Homepage" | translate }}</a
        >
        <button type="button" class="btn btn-primary" (click)="ngOnInit()">
          <i class="fa fa-file-text"></i> {{ "New request" | translate }}
        </button>
      </div>
    </div>
  </div>
}
